import { render, staticRenderFns } from "./InventoryItemFilters.vue?vue&type=template&id=5db248c8&scoped=true"
import script from "./InventoryItemFilters.vue?vue&type=script&lang=ts"
export * from "./InventoryItemFilters.vue?vue&type=script&lang=ts"
import style0 from "./InventoryItemFilters.vue?vue&type=style&index=0&id=5db248c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db248c8",
  null
  
)

export default component.exports